import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "14",
  height: "15"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M13.419 8.18c.322 0 .583.262.583.584v3.498a1.75 1.75 0 0 1-1.75 1.749h-10.5a1.75 1.75 0 0 1-1.75-1.75V8.765a.583.583 0 0 1 1.167 0v3.498c0 .322.261.583.583.583h10.5a.583.583 0 0 0 .584-.583V8.764c0-.322.26-.583.583-.583M7.176.04 7.163.037a.6.6 0 0 1 .322.221l3.428 3.429a.583.583 0 0 1-.825.824L7.582 2.007l.001 7.373a.583.583 0 0 1-1.166 0V2.025L3.918 4.52a.586.586 0 0 1-.829-.827L6.496.289a.58.58 0 0 1 .68-.249"
    }, null, -1)
  ])))
}
export default { render: render }